<template>
    <AppLayout>
        <div class="flex items-center justify-between">
            <div
                v-if="bill"
                class="flex flex-col"
            >
                <div class="mb-5">
                    <div class="flex items-center justify-center gap-4">
                        Bill Id:
                        <div class="mb-5">
                            <t-input
                                :value="bill.id"
                                disabled
                            />
                        </div>
                    </div>
                    <t-input
                        v-model="shippedPayload.driverName"
                        placeholder="Driver Name"
                    />
                    <t-input
                        v-model="shippedPayload.truckNumber"
                        placeholder="Truck Number"
                    />
                    <t-button
                        type="button"
                        variant="success"
                        @click="changeStatusToShipped()"
                    >
                        Shipped
                    </t-button>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
import axios from 'axios';
import AppLayout from '../../Layouts/AppLayout.vue';

export default {
    components: { AppLayout },
    props: {
        bill: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            shippedPayload: {
                driverName: 'test Name',
                truckNumber: '1234',
            },
        };
    },

    methods: {
        changeStatusToShipped() {
            axios.get(route('bill.shipped', this.billId), {
                headers: {
                    Accept: 'application/json',
                },
                params: this.shippedPayload,
            });
        },
    },
};
</script>
